import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import TriageCategorySelect from "./TriageCategorySelect";
import EncounterClassSelect from "./EncounterClassSelect";
import moment from "moment";
import {
  GetAllEncounterClass,
  GetAllEncounterInfo,
  GetAllSpecilaity,
} from "../config/preauthorizationApi";
import { useSearchParams } from "react-router-dom";

const Encounter = ({
  control,
  watch,
  setValue,
  setError,
  clearErrors,
  getFieldState,
}) => {
  const dispatch = useDispatch();
  const {
    stepFormData,
    preauthorizationDiagnosis,
    preauthorizationRequest,
    encounterClass,
    discharegSpeciality,
    serviceTypeListEncounter,
    actPeriortyList,
    triageCategoryList,
    emergencyArrivalList,
    departmentDispositionList,
    lengthOfStayList,
    encounterStatusList,
    adminResourceList,
    dischargeDispositionList,
    reAdmissionList,
    eventTypeList,
    admissionSpeciality,
  } = useSelector((state) => state.preauthorization);

  useEffect(() => {
    if (discharegSpeciality?.length === 0) dispatch(GetAllSpecilaity());
    if (encounterStatusList?.length === 0 || actPeriortyList?.length === 0)
      dispatch(GetAllEncounterInfo());
    if (encounterClass?.length === 0) dispatch(GetAllEncounterClass());
  }, []);

  useEffect(() => {
    setValue(
      "act_priority",
      actPeriortyList?.find((item) => item?.enctalltyp_code == "EL")
    );
  }, [setValue, actPeriortyList]);

  const isInstitual =
    stepFormData?.preauthorization_type?.claim_types_name === "Institutional";

  const isProfessionalOut =
    stepFormData?.preauthorization_type?.claim_types_name === "Professional" &&
    stepFormData?.preauthorization_sub_type?.claimsub_types_name ===
    "OutPatient";
  const isProfessionalEmer =
    stepFormData?.preauthorization_type?.claim_types_name === "Professional" &&
    stepFormData?.preauthorization_sub_type?.claimsub_types_name ===
    "Emergency";

  const isDental =
    stepFormData?.preauthorization_type?.claim_types_name === "Dental";

  const isNCHI = watch("payer")?.insurance_company_id === 41;

  const isEmptyVisitReason = !stepFormData?.visit_reason;

  useEffect(() => {
    if (stepFormData) {
      // Apply stepFormData values (assumes editing saved draft)
      Object.entries(stepFormData).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [stepFormData]);

  return (
    <Row>
      <Col xs={12} sm={6} xl={3}>
        <BootDatePicker
          name="admission_date"
          label="Admission Date"
          size="sm"
          control={control}
          rules={{
            required: true,

          }}
          selected={watch("admission_date")}
          onChange={(newValue) => {

            clearErrors("admission_date");
            setValue("admission_date", newValue);

          }}
          dateFormat="dd-mm-yyyy hh:mm"
          showTimeSelect
          isRequired={true}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <BootDatePicker
          name="discharge_date"
          label="Discharge Date"
          size="sm"
          control={control}
          rules={{
            required: false,
            validate: (dischargeDate) => {
              const admissionDate = watch("admission_date");
              if (!admissionDate || !dischargeDate) return true;

              // Normalize dates to compare only date parts (ignore time)
              const normalizedAdmission = new Date(
                admissionDate.getFullYear(),
                admissionDate.getMonth(),
                admissionDate.getDate()
              );
              const normalizedDischarge = new Date(
                dischargeDate.getFullYear(),
                dischargeDate.getMonth(),
                dischargeDate.getDate()
              );

              return (
                normalizedDischarge >= normalizedAdmission ||
                "Discharge date must be after or equal to admission date"
              );
            },
          }}
          selected={watch("discharge_date")}
          onChange={(newValue) => {
            setValue("discharge_date", newValue);
            const admissionDate = watch("admission_date");

            if (admissionDate && newValue) {
              // Normalize dates for comparison
              const normalizedAdmission = new Date(
                admissionDate.getFullYear(),
                admissionDate.getMonth(),
                admissionDate.getDate()
              );
              const normalizedDischarge = new Date(
                newValue.getFullYear(),
                newValue.getMonth(),
                newValue.getDate()
              );

              if (normalizedDischarge < normalizedAdmission) {
                setError("discharge_date", {
                  type: "custom",
                  message:
                    "Discharge date must be after or equal to admission date",
                });
              } else {
                clearErrors("discharge_date");
              }
            } else {
              clearErrors("discharge_date");
            }
          }}
          dateFormat="dd-mm-yyyy hh:mm"
          showTimeSelect
          isRequired={false}
        />
      </Col>
      {(!isInstitual || isNCHI) && !isDental && !isProfessionalOut && (
        <Col xs={12} sm={6} xl={3}>
          <BootDatePicker
            name="triage_date"
            label="Triage Date"
            size="sm"
            control={control}
            rules={{
              required:
                (!isNCHI && isProfessionalEmer) ||
                (isNCHI && isEmptyVisitReason),
            }}
            selected={watch("triage_date")}
            onChange={(newValue) => setValue("triage_date", newValue)}
            dateFormat="dd-mm-yyyy hh:mm"
            showTimeSelect
            maxDate={new Date()}
            isRequired={
              (!isNCHI && isProfessionalEmer) || (isNCHI && isEmptyVisitReason)
            }
          />
        </Col>
      )}
      {!isDental && !isProfessionalOut && (!isInstitual || isNCHI) && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">
            Triage Category{" "}
            {(!isNCHI && isProfessionalEmer) ||
              (isNCHI && isEmptyVisitReason && (
                <span className="text-danger">*</span>
              ))}
          </label>
          <Controller
            name="triage_category"
            control={control}
            rules={{
              required:
                (!isNCHI && isProfessionalEmer) ||
                (isNCHI && isEmptyVisitReason),
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={triageCategoryList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "triage_category",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}
      <Col xs={12} sm={6} xl={3}>
        <label className="form-label mb-2">
          Encounter Class{" "}
          {((isNCHI && isEmptyVisitReason) || !isNCHI) && (
            <span className="text-danger">*</span>
          )}
        </label>
        <Controller
          name="encounter_class"
          control={control}
          rules={{ required: (isNCHI && isEmptyVisitReason) || !isNCHI }}
          render={({ field }) => {
            // Filter options based on preauthorization type
            let filteredOptions = encounterClass;

            if (isDental) {
              filteredOptions = encounterClass?.filter(
                (item) => item.act_code === "AMB"
              );
            } else if (isProfessionalEmer) {
              filteredOptions = encounterClass?.filter(
                (item) => item?.act_code === "EMER"
              );
            } else if (isProfessionalOut) {
              filteredOptions = encounterClass.filter((item) =>
                ["AMB", "HH", "VR"].includes(item.act_code)
              );
            } else if (isInstitual && !isNCHI) {
              filteredOptions = encounterClass?.filter((item) =>
                ["SS", "IMP"].includes(item.act_code)
              );
            } else if (isNCHI) {
              filteredOptions = encounterClass?.filter((item) =>
                ["ACU"].includes(item?.act_code)
              );
            }

            return (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={filteredOptions?.map((item) => ({
                  value: item.act_code,
                  label: item.act_description,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.act_code,
                      label: field.value.act_description,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "encounter_class",
                    selected
                      ? {
                        act_code: selected.value,
                        act_description: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            );
          }}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <label className="form-label mb-2">
          Encounter Status {!isNCHI && <span className="text-danger">*</span>}
        </label>
        <Controller
          name="encounter_status"
          control={control}
          rules={{ required: !isNCHI }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={encounterStatusList?.map((item) => ({
                value: item.enctalltyp_code,
                label: item.enctalltyp_name,
              }))}
              value={
                field.value
                  ? {
                    value: field.value.enctalltyp_code,
                    label: field.value.enctalltyp_name,
                  }
                  : null
              }
              isClearable={true}
              onChange={(selected) => {
                setValue(
                  "encounter_status",
                  selected
                    ? {
                      enctalltyp_code: selected.value,
                      enctalltyp_name: selected.label,
                    }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <label className="form-label mb-2">Care Type</label>
        <Controller
          name="care_type"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={serviceTypeListEncounter?.map((item) => ({
                value: item.enctalltyp_code,
                label: item.enctalltyp_name,
              }))}
              value={
                field.value
                  ? {
                    value: field.value.enctalltyp_code,
                    label: field.value.enctalltyp_name,
                  }
                  : null
              }
              isClearable={true}
              onChange={(selected) => {
                setValue(
                  "care_type",
                  selected
                    ? {
                      enctalltyp_code: selected.value,
                      enctalltyp_name: selected.label,
                    }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <label className="form-label mb-2">Act Priority </label>
        <Controller
          name="act_priority"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              disabled={true}
              options={actPeriortyList?.map((item) => ({
                value: item.enctalltyp_code,
                label: item.enctalltyp_name,
              }))}
              value={
                field.value
                  ? {
                    value: field.value.enctalltyp_code,
                    label: field.value.enctalltyp_name,
                  }
                  : {
                    enctalltyp_code: "EL",
                    enctalltyp_name: "Elective",
                  }
              }
              isClearable={true}
              onChange={(selected) => {
                setValue(
                  "act_priority",
                  selected
                    ? {
                      enctalltyp_code: selected.value,
                      enctalltyp_name: selected.label,
                    }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>

      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">Discharge Speciality</label>
          <Controller
            name="discharge_speciality"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={discharegSpeciality?.map((item) => ({
                  value: item.specialities_code,
                  label: item.specialities_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.specialities_code,
                      label: field.value.specialities_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "discharge_speciality",
                    selected
                      ? {
                        specialities_code: selected.value,
                        specialities_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">Addmission Speciality</label>
          <Controller
            name="admission_speciality"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={admissionSpeciality?.map((item) => ({
                  value: item.specialities_code,
                  label: item.specialities_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.specialities_code,
                      label: field.value.specialities_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "admission_speciality",
                    selected
                      ? {
                        specialities_code: selected.value,
                        specialities_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {(!isInstitual || isNCHI) && !isDental && !isProfessionalOut && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">
            Emergency Department Disposition
            {isNCHI && isEmptyVisitReason && (
              <span className="text-danger">*</span>
            )}{" "}
          </label>
          <Controller
            name="emer_department_disposition"
            control={control}
            rules={{
              required: isNCHI && isEmptyVisitReason,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={departmentDispositionList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "emer_department_disposition",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">
            Encounter AdmitSource{" "}
            {isInstitual && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="encounter_admitsource"
            control={control}
            rules={{ required: isInstitual }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={adminResourceList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "encounter_admitsource",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">Discharge Disposition</label>
          <Controller
            name="discharge_disposition"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={dischargeDispositionList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "discharge_disposition",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      <Col xs={12} sm={6} xl={3}>
        <label className="form-label mb-2">Cause Of Death</label>
        <Controller
          name="cause_of_death"
          control={control}
          rules={{
            required: false,
            validate: (value) => {
              const dischargeCode = watch(
                "discharge_disposition"
              )?.enctalltyp_code;
              const emergencyCode = watch(
                "emer_department_disposition"
              )?.enctalltyp_code;

              if (
                (isInstitual || isProfessionalOut) &&
                (dischargeCode === "died" ||
                  ["DED", "DOA"].includes(emergencyCode))
              ) {
                return (
                  !!value ||
                  "Cause of Death is required when patient died or DOA/DED"
                );
              }
              return true;
            },
          }}
          render={({ field, fieldState }) => (
            <>
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                value={
                  field?.value
                    ? {
                      label: field?.value?.description,
                      code: field?.value?.code,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "cause_of_death",
                    selected
                      ? {
                        code: selected?.code,
                        description: selected?.label,
                      }
                      : null
                  );
                }}
                options={preauthorizationDiagnosis?.map((item) => ({
                  label: item.description,
                  code: item.code,
                }))}
                isClearable={true}
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => `(${option.code}) ${option.label}`}
              />
            </>
          )}
        />
      </Col>

      {(!isInstitual || isNCHI) && !isDental && !isProfessionalOut && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">Emer. Arrival Code</label>

          <Controller
            name="emergncy_arrival_code"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={emergencyArrivalList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "emergncy_arrival_code",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {!isInstitual && !isDental && !isProfessionalOut && (
        <Col xs={12} sm={6} xl={3}>
          <BootDatePicker
            name="emergency_service_start_date"
            label="Emer. Service Start Date"
            size="sm"
            control={control}
            rules={{ required: false }}
            selected={watch("emergency_service_start_date")}
            onChange={(newValue) =>
              setValue("emergency_service_start_date", newValue)
            }
            placeholder="dd/mm/yyyy"
            maxDate={new Date()}
            isRequired={false}
          />
        </Col>
      )}

      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">ReAdmission </label>
          <Controller
            name="readmission"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={reAdmissionList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "readmission",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}

      {!isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">
            Service Event Type <span className="text-danger">*</span>
          </label>
          <Controller
            name="service_event_type"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={eventTypeList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.enctalltyp_code,
                      label: field.value.enctalltyp_name,
                    }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "service_event_type",
                    selected
                      ? {
                        enctalltyp_code: selected.value,
                        enctalltyp_name: selected.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}
      {/* {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <label className="form-label mb-2">
            Intended Length Of Stay{" "}
            {isInstitual && !isNCHI && <span className="text-danger">*</span>}{" "}
          </label>
          <Controller
            name="intend_length_stay"
            control={control}
            rules={{ required: isInstitual && !isNCHI }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={lengthOfStayList?.map((item) => ({
                  value: item.enctalltyp_code,
                  label: item.enctalltyp_name,
                }))}
                value={
                  field.value
                    ? {
                        value: field.value.enctalltyp_code,
                        label: field.value.enctalltyp_name,
                      }
                    : null
                }
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "intend_length_stay",
                    selected
                      ? {
                          enctalltyp_code: selected.value,
                          enctalltyp_name: selected.label,
                        }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )} */}
      {isInstitual && (
        <Col xs={12} sm={6} xl={3}>
          <TextInput
            name="estimated_length_stay"
            label="Estimated Length of Stay"
            control={control}
            size="sm"
            min={0}
            max={999}
            type="number"
            rules={{ required: true }}
            required={true}
          />
        </Col>
      )}
      <Col xs={12} sm={6} xl={3}>
        <BootDatePicker
          name="last_menstrual_code"
          label="Last Menstrual Cycle"
          size="sm"
          control={control}
          rules={{ required: false }}
          selected={watch("last_menstrual_code")}
          onChange={(newValue) => setValue("last_menstrual_code", newValue)}
          dateFormat="dd-mm-yyyy"
          maxDate={new Date()}
          isRequired={false}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <BootDatePicker
          name="empoly_impact_start_date"
          label="Empoly. Impact Start Date"
          size="sm"
          control={control}
          rules={{ required: watch("empoly_impact_end_date") }}
          selected={watch("empoly_impact_start_date")}
          onChange={(newValue) =>
            setValue("empoly_impact_start_date", newValue)
          }
          dateFormat="dd-mm-yyyy"
          placeholder={"dd-mm-yyyy"}
          isRequired={watch("empoly_impact_end_date")}
        />
      </Col>
      <Col xs={12} sm={6} xl={3}>
        <BootDatePicker
          name="empoly_impact_end_date"
          label="Empoly. Impact End Date"
          size="sm"
          control={control}
          rules={{ required: watch("empoly_impact_start_date") }}
          selected={watch("empoly_impact_end_date")}
          onChange={(newValue) => setValue("empoly_impact_end_date", newValue)}
          dateFormat="dd-mm-yyyy"
          placeholder={"dd-mm-yyyy"}
          isRequired={watch("empoly_impact_start_date")}
        />
      </Col>
    </Row>
  );
};

export default Encounter;
